module.exports = __webpack_public_path__ + "img/gbx.b2fb1728.svg";